<template lang="html">
  <div class="">
    <vx-card
        v-for="destino in destinos"  :key="destino.Id"
        title-color="primary"
        style="margin-bottom:5%"
        :id="destino.Id"
        class="destino"
        @click="seleccionar(destino.Id)">
        <h4>{{destino.Nombre}}</h4>
    </vx-card>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      destinos:[
        {'Id':1, 'Nombre':'Adquisición de vivienda'},
        {'Id':3, 'Nombre':'Liquidez'},
        {'Id':5, 'Nombre':'Adquisición de Terreno'},
        {'Id':19, 'Nombre':'Mejora de hipoteca'},
      ],
      key:''
    }
  },
  mounted(){
    this.key=this.$route.params.key
  },
  methods: {
    seleccionar(id){
      this.$emit('destino',id)
      for (var i = 0; i < this.destinos.length; i++) {
        document.getElementById(this.destinos[i].Id).style.backgroundColor = "white";
      }
      document.getElementById(id).style.backgroundColor = "lightgray";
    }
  },
}
</script>

<style lang="css" scoped>
h4{
  text-align: center;
  color: rgba(var(--vs-primary), 1);
}
</style>
